import React, { Component } from "react";
import { Input, DatePicker } from "antd";

import { Dropdown } from "../../../../components/common/dropdown";
import { apiVehicle } from "../../../../api/api-vehicle";
import { emitter } from "../../../../common/utils/emitter";
import { apiConstract } from "../../../../api/api-constract";

export class TableSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      car_type: "",
      number_plate: "",
      color: "",
      number_seat: "",
      model: "",
      status: "",
      resource: "",
      car_resource: [],
      car_status: [],
      checkSearch: false,
      travel_warrant_expiry_date: null,
      registration_to_date: null,
      road_fee_expiry_date: null,
      branchList: [],
      branch_id: null,
    };
    //this.branchs = [];
  }

  componentWillReceiveProps(newProps) {
    if (newProps.has_driver !== this.props.has_driver) {
      this.dropdown.setState({
        title: "Trạng thái",
        titleColor: "colorTitleFirst",
      });
      this.setState({ status: null });
    }
  }

  async componentDidMount() {
    try {
      const [getOptions, dataBranch] = await Promise.all([
        apiVehicle.getCarFilterOptions(),
        apiConstract.getBranch(),
      ]);

      if (dataBranch.status == "success") {
        let dataConvert = dataBranch.data.map((item) => ({
          ...item,
          name: item.code,
        }));
        dataConvert.unshift({ id: -1, code: "all", name: "Tất cả" });
        this.setState({ branchList: dataConvert });
      }

      if (getOptions.status == "success") {
        this.dataOptions = getOptions.data;
        this.setOptionState();
      }
    } finally {
      emitter.emit("FETCH_LOADING", false);
    }
  }

  setOptionState = () => {
    if (!this.dataOptions) {
      return;
    }
    const { status, supplier_groups } = this.dataOptions;

    supplier_groups.unshift({ id: -1, code: "all", name: "Tất cả" });
    status.unshift({ value: -1, name: "Tất cả" });
    this.setState({
      car_resource: supplier_groups,
      car_status: status.map((item) => {
        return { ...item, code: item.value };
      }),
      checkSearch: false,
    });
  };

  onChangeText = (feild, value) => {
    this.setState({ [feild]: value, checkSearch: false });
  };

  search = (event) => {
    if (event.keyCode === 13) {
      this.submitSearch();
      event.preventDefault();
    }
  };

  submitSearch = async () => {
    await this.setState({
      checkSearch: true,
    });
    this.props.search(1);
  };

  setStatus = (value) => {
    if (value.id == -1) {
      this.setState({ status: null, checkSearch: false });
    } else {
      this.setState({ status: value.value, checkSearch: false });
    }
  };

  setCarResource = (value) => {
    if (value.id == -1) {
      this.setState({ resource: null, checkSearch: false });
    } else {
      this.setState({ resource: value.id, checkSearch: false });
    }
  };

  handleChangeNumberSeat = (e) => {
    const { value } = e.target;
    this.onChangeText("number_seat", value.replace(/\D+/g, ""));
  };

  handleChangeDate = (name, date) => {
    this.setState({
      [name]: date
        ? date
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x")
        : null,
    });
  };

  setBranch = (value) => {
    if (value.id == -1) {
      this.setState({
        branch_id: null,
        checkSearch: false,
      });
    } else {
      this.setState({
        branch_id: value.id,
        checkSearch: false,
      });
    }
  };

  render() {
    const {
      car_type,
      number_plate,
      number_seat,
      color,
      model,
      car_status,
      car_resource,
      branchList,
    } = this.state;

    return (
      <div className="search-bar">
        <div className="search-user-container">
          <div className="search-contract">
            <DatePicker
              onChange={(date) =>
                this.handleChangeDate("travel_warrant_expiry_date", date)
              }
              className="input"
              format="DD/MM/YYYY"
              placeholder="Ngày hết hạn giấy đi đường"
            />
            <DatePicker
              onChange={(date) =>
                this.handleChangeDate("registration_to_date", date)
              }
              className="input"
              format="DD/MM/YYYY"
              placeholder="Ngày đăng kiểm tới"
            />
            <DatePicker
              onChange={(date) =>
                this.handleChangeDate("road_fee_expiry_date", date)
              }
              className="input"
              format="DD/MM/YYYY"
              placeholder="Ngày hết hạn phí đường bộ"
            />
          </div>
          <div className="search-contract">
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("number_plate", param.target.value)
              }
              value={number_plate}
              placeholder="Biển KS"
              className="input"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("model", param.target.value)
              }
              value={model}
              placeholder="Model"
              className="input"
            />
            <Dropdown
              select={(value) => this.setCarResource(value)}
              className="input"
              menu={car_resource}
              title="Nguồn xe"
            />
          </div>
          <div className="search-contract">
            <Dropdown
              select={(value) => this.setBranch(value)}
              className="input"
              menu={branchList}
              title="Khu vực quản lý"
            />
          </div>
        </div>
        <div onClick={this.submitSearch} className="btn-success">
          <img
            alt=""
            onClick={this.submitSearch}
            style={{ objectFit: "contain", cursor: "pointer", marginRight: 5 }}
            width={16}
            src={require("../../../../assets/icons/search-solid-white.png")}
          />
          Search
        </div>
      </div>
    );
  }
}
